let csrfToken: string | null = null;

/**
 * Keeps the BFF-issued CSRF token in memory only. Call with null on logout or
 * any response that invalidates the authenticated session.
 */
export function setCsrfToken(value: string | null): void {
  if (value !== null && (value.length < 16 || value.length > 512 || containsUnsafeCharacter(value))) {
    throw new TypeError("Invalid CSRF token.");
  }

  csrfToken = value;
}

function containsUnsafeCharacter(value: string): boolean {
  return Array.from(value).some((character) => {
    const code = character.codePointAt(0) ?? 0;
    return code <= 32 || code === 127;
  });
}

export function requireCsrfToken(): string {
  if (csrfToken === null) {
    throw new MissingCsrfTokenError();
  }

  return csrfToken;
}

export class MissingCsrfTokenError extends Error {
  constructor() {
    super("A CSRF token is required for administrative mutations.");
    this.name = "MissingCsrfTokenError";
  }
}
